import BharatImg from "../../assets/images/denim/BharatFull.webp";
import RaviImg from "../../assets/images/denim/RaviFull.webp";
import PankajImg from "../../assets/images/denim/PankajFull.webp";
import SonuImg from "../../assets/images/denim/SonuFull.webp";
import DeepakImg from "../../assets/images/denim/DeepakFull.webp";
import starImg1 from "../../assets/images/testimonial/Stars.png";
import starImg2 from "../../assets/images/testimonial/Stars4.5.png";
import NandanBG from "../../assets/images/featured_mills/NandanBG.webp";
import NandanLogo from "../../assets/images/featured_mills/NandanLogo.png";
import VinodBG from "../../assets/images/featured_mills/VinodBG.webp";
import VinodLogo from "../../assets/images/featured_mills/VinodLogo.webp";
import BhaskarBG from "../../assets/images/featured_mills/BhaskarBG.webp";
import BhaskarLogo from "../../assets/images/featured_mills/BhaskarLogo.png";
import KGDenimBG from "../../assets/images/featured_mills/KGDenimBG.webp";
import KGDenimLogo from "../../assets/images/featured_mills/KGDenimLogo.png";
import ShantiBG from "../../assets/images/featured_mills/ShantiBG.webp";
import ShantiLogo from "../../assets/images/featured_mills/ShantiLogo.webp";
import IndoTexBG from "../../assets/images/featured_mills/IndotexBG.webp";
import IndoTexLogo from "../../assets/images/featured_mills/IndotexLogo.png";
import ModernBG from "../../assets/images/featured_mills/ModernBG.webp";
import ModernLogo from "../../assets/images/featured_mills/ModernLogo.png";
import JindalBG from "../../assets/images/featured_mills/JindalBG.webp";
import JindalLogo from "../../assets/images/featured_mills/JindalLogo.png";

export const DENIM_HERO_TEXT =
  "Source Premium Denim Directly from Verified Mills";

export const DENIM_HERO_SUBTEXT =
  "Compare competitive factory prices, consistent quality, and reliable dispatch all in one place.";

export const FEATURED_MILLS = [
  {
    id: 1,
    label: "Nandan Denim",
    backgroundImage: NandanBG,
    logo: NandanLogo,
    millLink: "https://nandandenim.com/",
  },
  {
    id: 2,
    label: "Vinod Denim",
    backgroundImage: VinodBG,
    logo: VinodLogo,
    millLink: "https://vinoddenim.com/",
  },
  {
    id: 3,
    label: "Shanti Spintex",
    backgroundImage: ShantiBG,
    logo: ShantiLogo,
    millLink: "https://www.shantispintex.com/",
  },
  {
    id: 4,
    label: "Indotex Exports",
    backgroundImage: IndoTexBG,
    logo: IndoTexLogo,
    millLink: "https://www.indotexexports.com/",
  },
  {
    id: 5,
    label: "Bhaskar Denim",
    backgroundImage: BhaskarBG,
    logo: BhaskarLogo,
    millLink: "https://www.bhaskarindustries.com/",
  },
  {
    id: 6,
    label: "K G Denim",
    backgroundImage: KGDenimBG,
    logo: KGDenimLogo,
    millLink: "http://www.kgdenim.com/",
  },
  {
    id: 7,
    label: "Modern Denim",
    backgroundImage: ModernBG,
    logo: ModernLogo,
    millLink: "https://www.moderndenim.com/",
  },
  {
    id: 8,
    label: "Jindal Textiles",
    backgroundImage: JindalBG,
    logo: JindalLogo,
    millLink: "https://www.jindaltextiles.com/products.php",
  },
];

export const TESTIMONIALS = [
  {
    img: RaviImg,
    customer: "Ravi Khandelwal",
    subtitle: "Jaipur",
    description:
      "The first time, I was placing the order, I was doubtful about the fabric quality. In the past when I ordered online, I have had a very disappointing product. But the team sent me a sample. I became more confident and place the order.",
    starImg: starImg1,
  },
  {
    img: PankajImg,
    customer: "Pankaj",
    subtitle: "Gurugram",

    description:
      "I was surprised to see my order being delivered before time, without any follow up. I have worked with many suppliers in the past but only with Locofast I had an easy, worry-free experience. I surely see myself placing orders on Locofast again.",
    starImg: starImg2,
  },
  {
    img: BharatImg,
    customer: "Bharat Kumar ",
    subtitle: "Jaipur",
    description:
      "The entire team is very professional and transparent in their process. Their team went above and beyond in ensuring that my order gets delivered to me on-time and hassel free.The best part was that I could trace my order status until it was delivered.",
    starImg: starImg1,
  },
  {
    img: SonuImg,
    customer: "Sonu Singh",
    subtitle: "Faridabad",
    description:
      "Locofast is transparent with what they do. In textile industry, it is quite unusual to find such partners whom you can trust.",
    starImg: starImg2,
  },
  {
    img: DeepakImg,
    customer: "Deepak Kumar",
    subtitle: "Noida",

    description:
      "Locofast is one complete solution. The best thing about them is that they have a committed team who helps you with everything like assured quality and best price rate. I am glad to have partnered with them.",
    starImg: starImg1,
  },
];
